import { getCurrentInstance } from 'vue';
import { getBrandLogoUrl, getCategoryIconUrl } from '@/utils/helpers';
// Merchant-avatar rule shared by TransactionsList and TransactionGroupCard:
// brand logo only for well-known merchants, otherwise the category icon (on its
// colour) or the income/round3 fallback. Mirrors the wellKnownLogosOnly global
// with a localStorage override.
export function useTransactionAvatar() {
    const wellKnownLogosOnly = getCurrentInstance()?.appContext.config.globalProperties.$wellKnownLogosOnly;
    const round3Path = require('@/assets/round3.png');
    function getClassificationIcon(t) {
        const classification = t.effectiveClassification || t.originalClassification;
        return getCategoryIconUrl(classification?.iconPath);
    }
    function classificationIconIsFallback(t) {
        return getClassificationIcon(t) === round3Path;
    }
    function getTransactionLogoUrl(t) {
        const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
            ? localStorage.getItem('wellKnownLogosOnly') === 'true'
            : wellKnownLogosOnly;
        if (wellKnown) {
            const isKnown = !!t.merchant || t.wellKnownMerchant === true;
            if (!isKnown)
                return getClassificationIcon(t);
        }
        else {
            if (t.amount >= 0) {
                return require('@/assets/round1.png');
            }
        }
        return getBrandLogoUrl(t.merchant ? t.merchant.name : t.merchantName);
    }
    function isCategoryIconShown(t) {
        const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
            ? localStorage.getItem('wellKnownLogosOnly') === 'true'
            : wellKnownLogosOnly;
        if (!wellKnown)
            return false;
        const isKnown = !!t.merchant || t.wellKnownMerchant === true;
        if (isKnown)
            return false;
        if (classificationIconIsFallback(t))
            return false;
        return true;
    }
    function handleLogoError(event, t) {
        event.target.src = getClassificationIcon(t);
    }
    // Tints the icon background with the category colour, so the white-on-transparent
    // category PNG fallback sits on its tree colour instead of the neutral grey.
    function getIconStyle(t) {
        const wellKnown = localStorage.getItem('wellKnownLogosOnly') !== null
            ? localStorage.getItem('wellKnownLogosOnly') === 'true'
            : wellKnownLogosOnly;
        if (!wellKnown) {
            if (t.amount >= 0)
                return {};
        }
        else if (classificationIconIsFallback(t)) {
            return {};
        }
        const colour = t.effectiveClassification?.color;
        if (!colour)
            return {};
        return { backgroundColor: colour };
    }
    return {
        getClassificationIcon,
        classificationIconIsFallback,
        getTransactionLogoUrl,
        isCategoryIconShown,
        handleLogoError,
        getIconStyle,
    };
}
